import React from 'react';

const services = [
  {
    icon: 'ri-home-line',
    title: '不動産登記',
    description: '土地・建物の売買、相続、贈与などの不動産登記手続きを迅速かつ正確に行います。',
    image: 'https://public.readdy.ai/ai/img_res/50e84d5e2f7f34f0edf262aa837824c1.jpg'
  },
  {
    icon: 'ri-building-line',
    title: '商業登記',
    description: '会社設立、役員変更、本店移転など、企業の商業登記に関する手続きをサポートします。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20Japanese%20office%20building%2C%20corporate%20headquarters%2C%20glass%20facade%2C%20professional%20architecture%2C%20urban%20business%20district%2C%20clean%20design%2C%20no%20text%20or%20signage%20visible&width=400&height=300&seq=service2&orientation=landscape'
  },
  {
    icon: 'ri-heart-line',
    title: '相続手続き',
    description: '相続登記、遺産分割協議書作成など、相続に関する複雑な手続きを丁寧にサポートします。',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20family%20consultation%20meeting%2C%20elderly%20parents%20with%20adult%20children%2C%20warm%20family%20atmosphere%2C%20comfortable%20living%20room%20setting%2C%20natural%20lighting%2C%20no%20text%20visible&width=400&height=300&seq=service3&orientation=landscape'
  },
  {
    icon: 'ri-shield-check-line',
    title: '債務整理',
    description: '任意整理、個人再生、自己破産など、借金問題の解決に向けた最適な方法をご提案します。',
    image: 'https://readdy.ai/api/search-image?query=Professional%20Japanese%20consultation%20scene%2C%20advisor%20helping%20client%20with%20documents%2C%20serious%20but%20supportive%20atmosphere%2C%20modern%20office%20interior%2C%20natural%20lighting%2C%20no%20text%20visible&width=400&height=300&seq=service4&orientation=landscape'
  },
  {
    icon: 'ri-user-heart-line',
    title: '成年後見',
    description: '認知症や知的障害などにより判断能力が不十分な方の権利を守る成年後見制度をサポートします。',
    image: 'https://readdy.ai/api/search-image?query=Caring%20Japanese%20caregiver%20with%20elderly%20person%2C%20warm%20and%20supportive%20interaction%2C%20comfortable%20home%20environment%2C%20natural%20lighting%2C%20compassionate%20atmosphere%2C%20no%20text%20visible&width=400&height=300&seq=service5&orientation=landscape'
  },
  {
    icon: 'ri-file-text-line',
    title: 'その他法務',
    description: '契約書作成、内容証明郵便、各種法的書類の作成など、幅広い法務サービスを提供します。',
    image: 'https://readdy.ai/api/search-image?query=Professional%20Japanese%20legal%20documents%20and%20contracts%20on%20desk%2C%20organized%20paperwork%2C%20modern%20office%20setting%2C%20natural%20lighting%2C%20clean%20and%20professional%20atmosphere%2C%20no%20text%20visible&width=400&height=300&seq=service6&orientation=landscape'
  }
];

export const Services: React.FC = () => {
  return (
    <section className="py-12 md:py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3 md:mb-4">サービス内容</h2>
          <p className="text-base md:text-xl text-gray-600 max-w-3xl mx-auto px-4">
            おかやま司法書士事務所では、不動産登記から相続手続きまで、
            幅広い司法書士業務を通じてお客様をサポートいたします。
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
              <div className="h-40 md:h-48 overflow-hidden">
                <img 
                  src={service.image} 
                  alt={service.title}
                  className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-5 md:p-6">
                <div className="flex items-center mb-3 md:mb-4">
                  <div className="w-10 h-10 md:w-12 md:h-12 bg-blue-100 rounded-lg flex items-center justify-center mr-3 md:mr-4 flex-shrink-0">
                    <i className={`${service.icon} text-xl md:text-2xl text-blue-600`}></i>
                  </div>
                  <h3 className="text-lg md:text-xl font-semibold text-gray-900">{service.title}</h3>
                </div>
                <p className="text-sm md:text-base text-gray-600 leading-relaxed">{service.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
